// extracted by mini-css-extract-plugin
export var divider = "_q5-0";
export var systemMessage = "_q5-1";